module.exports = __webpack_public_path__ + "media/images/icons/filled/credit-card-99d8efa703b02aa2a69dc92f2ad8aaf5.svg";